<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12 gifted-card"  :style="{ backgroundImage: `url(${card_bg})` }">
            	<div class="left-content">
            		<table border="0" cellpadding="0" cellspacing="0" style=" width: 100%; margin: 0; border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; ">
								<tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
									<td><b>Dear {{ this.recipient_name }}</b></td>
								</tr>
								<tr>
									<td>{{ this.message }}</td>
								</tr>
								<tr>
									<td><b>{{ this.sender_name }}</b></td>
								</tr>
							</table>
            	</div>
            	<div class="right-content">
            		<table border="0" cellpadding="0" cellspacing="0" style="margin: 0; border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; ">
						<tr>
							<td>
								<img width="147" v-bind:src="'https://gifted.ph/uploads/greeting_cards/category_icons/' + this.category_icon" v-bind:alt="this.product_name"  v-bind:title="this.product_name" />
							</td>
						</tr>
						<tr>
							<td><b>{{ this.product_suggestion }}</b></td>
						</tr>
						<tr>
							<td>at <b>{{ this.product_name }}</b></td>
						</tr>
						<tr>
							<td><b>&#8369; {{ this.amount }}</b></td>
						</tr>
					</table>
            	</div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .gifted-card{
		max-width: 800px;
		margin: 15px auto;
		border: 1px solid #ccc;
		padding: 0;
		background-size: 100%; 
		background-repeat: no-repeat;
    }
    .gifted-card .left-content{
    	float: left; 
    	width: 38%;
    	padding: 255px 10px 0 5px;
    	height: 448px;
    	color: #ffffff;
    }
    .gifted-card .left-content b{
    	font-weight: bold;
   		font-size: 15px;
    	line-height: 15px;
    }
    .gifted-card .right-content{
    	float: left; 
    	width: 62%;
    	text-align: center;
    	padding-top: 130px;
    }
    .gifted-card .right-content img{
    	margin-bottom: 24px;
    }
    .gifted-card .right-content b{
    	font-weight: bold;
   		font-size: 15px;
    	line-height: 15px;
    }
    .gifted-card .right-content table{
    	width: 95%;
    }
    @media only screen and (max-width: 991px) {
    	.gifted-card .left-content{
    		height: 403px;
    	}
    	.gifted-card .right-content{
    		padding-top: 112px;
    	}
    	.gifted-card .right-content img{
		    margin-bottom: 15px;
		}
    }
    @media only screen and (max-width: 767px) {
    	.gifted-card{
    		background-size: contain;
    		max-width: 320px;
    	}
    	.gifted-card .left-content{
    		width: 100%;
    		padding-top: 370px;
    		padding-left: 10px;
    		height: auto;
    		color: #000;    	}
    	.gifted-card .right-content{
    		width: 100%;
    	    padding-top: 20px;
    	}
    	.gifted-card .right-content img{
    		width: 70px;
    	}
    	.gifted-card .right-content table{
	    	width: 100%;
	    	padding-bottom: 20px;
	    }
    }
</style>
<script>
    export default {
        props: ['details'],
        data(){
            return {
                card_id: "",
                product_name: "",
                product_suggestion: "",
                category_icon: "",
                amount: "",
                recipient_name: "",
                sender_name: "",
                message: "",
                card_desktop: "",
                card_mobile: "",
                width: 0,
            	height: 0,
            	card_bg: 0,
            }
        },
        mounted() {

            const card = JSON.parse(this.details)
            //this.card_desktop = 'https://gifted.ph/uploads/greeting_cards/cards/'+card.card_id+'.jpg';
            //this.card_mobile = 'https://gifted.ph/uploads/greeting_cards/onepage/'+card.card_id+'.jpg';
            this.product_name = card.product_name;
            this.product_suggestion = card.product_suggestion;
            this.category_icon = card.category_icon;
            this.amount = card.amount;
            this.recipient_name = card.recipient_name;
            this.sender_name = card.sender_name;
            this.message = card.message;

       
        },
        created() {
	        window.addEventListener('resize', this.handleResize);
	        this.handleResize();
	    },
	    destroyed() {
	        window.removeEventListener('resize', this.handleResize);
	    },
	    methods: {
	        handleResize() {
	            this.width = window.innerWidth;
	            this.height = window.innerHeight;

	            const card = JSON.parse(this.details)
	            if(window.innerWidth > 767){
	            	this.card_bg = 'https://gifted.ph/uploads/greeting_cards/cards/'+card.card_id+'.jpg';
	            }else{
	            	this.card_bg = 'https://gifted.ph/uploads/greeting_cards/onepage/'+card.card_id+'.jpg';
	            }
	        }
	    }
    }



</script>
